<button mat-icon-button type="button" [matMenuTriggerFor]="classificationsMenu"
        aria-label="AI classifications" matTooltip="AI classifications" class="classification-trigger">
  <mat-icon>psychology</mat-icon>
  @if (badgeCount$ | async; as count) {
    @if (count > 0) {
      <span class="classification-badge" aria-label="{{ count }} classifications need attention">{{ count > 99 ? '99+' : count }}</span>
    }
  }
</button>

<mat-menu #classificationsMenu="matMenu" class="classification-menu">
  @if (summary$ | async; as summary) {
    <div class="classification-title" (click)="$event.stopPropagation()">AI classifications</div>
    <div class="classification-group" (click)="$event.stopPropagation()">Needs your answer ({{ summary.needsAnswer }})</div>
    @for (item of itemsFor(summary, 'needs_answer'); track item.determinationId) {
      <button mat-menu-item type="button" (click)="open(item)">
        <span class="classification-item"><strong>{{ item.description }}</strong><small>{{ item.rfqId != null ? 'RFQ ' + item.rfqId : 'HTS Lookup' }}</small></span>
      </button>
    }
    <div class="classification-group" (click)="$event.stopPropagation()">Ready to apply ({{ summary.ready }})</div>
    @for (item of itemsFor(summary, 'ready'); track item.determinationId) {
      <button mat-menu-item type="button" (click)="open(item)">
        <span class="classification-item"><strong>{{ item.description }}</strong><small>{{ item.rfqId != null ? 'RFQ ' + item.rfqId : 'HTS Lookup' }}</small></span>
      </button>
    }
    <div class="classification-group" (click)="$event.stopPropagation()">Running ({{ summary.running }})</div>
    @for (item of itemsFor(summary, 'running'); track item.determinationId) {
      <button mat-menu-item type="button" (click)="open(item)">
        <span class="classification-item"><strong>{{ item.description }}</strong><small>{{ item.rfqId != null ? 'RFQ ' + item.rfqId : 'HTS Lookup' }}</small></span>
      </button>
    }
    @if (!summary.items.length) {
      <div class="classification-empty" (click)="$event.stopPropagation()">No active classifications</div>
    }
    <button mat-menu-item type="button" (click)="viewAll()">View all classifications</button>
  } @else {
    <div class="classification-empty" (click)="$event.stopPropagation()">Classifications are unavailable</div>
  }
</mat-menu>
